import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import './css/StaffsComponent1.css';
import { context } from '../../../../globalState/GlobalState';
import Spinner1 from '../../spinners/spinner1/Spinner1';
import Title1 from '../../title/title1/Title1';
import { isValidObject, isValidString } from '../../../../catalog/Validity';
import StaffThumbnail1 from '../../staffThumbnails/staffThumbnail1/StaffThumbnail1';

const StaffsComponent1 = (props) => {
    const { staffs, loadingSpinner } = props;
    const { globalState } = useContext(context);

    return (
        <>
            <div className="staffs-component1-container x-center bg-white curve-border-30px box-shadow-black p-t-20px p-l-100px p-r-100px p-b-100px m-t-50px m-b-30px">
                <Title1 title="Executive Board" />
                <div className="staffs-component1">
                    {loadingSpinner ? (<Spinner1 color={globalState.websiteStyles.colors.primaryColor} />) : (
                        <>
                            {staffs.length > 0 ? (
                                <>
                                    {staffs.map((staff) => {
                                        return (
                                            <React.Fragment key={staff.id}>
                                                <StaffThumbnail1 staff={staff} />
                                            </React.Fragment>
                                        );
                                    })}
                                </>
                            ) : (<p className="alegreya-font-family font-weight-800 font-size-4xl full-width text-center-align">Executive Board Unavailable</p>)}
                        </>
                    )}
                    {isValidObject(globalState.logo) && isValidString(globalState.logo.logo2) ? (
                        <img src={globalState.logo.logo2} className="staffs-component1-icon m-t-50px m-b-0" alt={isValidString(globalState.teamName) ? globalState.teamName : 'Team Logo'} />
                    ) : null}
                </div>
            </div>
        </>
    );
};

StaffsComponent1.propTypes = {
    staffs: PropTypes.array.isRequired,
    loadingSpinner: PropTypes.bool.isRequired,
};

export default memo(StaffsComponent1);
